import Emitter from '../../../src/core/Emitter.js';
import Widget from '../../../src/dashboard/Widget.jsx';
import InstantWidget from '../../../src/dashboard/InstantWidget.jsx';
import ModelStatus from '../../../src/data/ModelStatus.js';
import Utility from '../../../src/core/Utility.js';
import WidgetService from '../../../src/dashboard/WidgetService.js';

const DISPLAY_MAX = 100;

class AddNewWidgetController {
	constructor($scope, $element, $compile, $filter, $translate, $timeout, serviceWidget, serviceWorkerLogdb, serviceLogdb) {
		this.el = $element;
        this.scope = $scope;
        this.$filter = $filter;
        this.$translate = $translate;
		this.$compile = $compile;
		this.$timeout = $timeout;
		this.widgetTypes = serviceWidget.getTypes();
		this.serviceWorkerLogdb = serviceWorkerLogdb;
		this.serviceLogdb = serviceLogdb;
		this.isSourceLoading = false;
		this.currentDataSource;
		this.isSourceChanged = false;

		this.current = {
			widget: {
				data: null
			},
			type: this.widgetTypes[0]
		};

		this.bindFields = this.bindFields.bind(this);
		this.drawSheet = this.drawSheet.bind(this);

		this.scope.$on('DashboardContainerController:getCurrentPreset', this.initAddWidgetWindow.bind(this));
		this.scope.$on('onContextContainerChanged', this.onContextContainerChanged.bind(this));
		this.scope.$watch('vm.isDarkMode', this.toggleDarkMode.bind(this));

		$(window).on('resize.addnewwidget', Utility.debounce((e) => {
			if(!this.previewWidget || !this.previewWidget.rendered) {
				return ;
			}
			let el = this.el.find('.js-preview.widget-container');
			let w = el.width();
			let h = el.height();

			// 차트 위젯이 아닐 때도 이 부분이 호출되기 때문에 에러가 나기 때문에 에러 처리. (예: 지도 위젯의 resize)
			if(!!this.previewWidget.rendered.chart) {
				// this.previewWidget.rendered.chart.highcharts().setSize(w, h, false);
				this.previewWidget.rendered.onResize(null, w, h);
			}
		}, 100));

		this.scope.$watch('vm.current.widget.data.source.guid', (newguid, oldguid) => {
			var ctxcnt = this.el.find('*[context-container]')[0];
			if(!ctxcnt) {
				return;
			}

			if(!!newguid) {
				ctxcnt.setHaveDatasource(true);
			}
			else {
				ctxcnt.setHaveDatasource(false);
			}

		});

	}

	initAddWidgetWindow(e, preset) {
		console.warn('initAddWidgetWindow');
		this.isQueryExecuted = false;
		this.previewWidget = null;
		this.preset = preset;
		this.store = preset.store;
		this.dataModel = [];
		this.dataModelForGrid = [];
		this.columnInfo = [];
		this.clearSheet();
		this.clearWidgetContext();
		this.isOnSubmit = false;
		this.isSheetLoaded = false;
		this.isSourceLoading = false;
		// added in issue2712
		this.isSourceChanged = false;
		//
		//only for widgets using stream query.
		this.streamQueryValid = false;
		//
		this.preset.stopTimer();
		this.$timeout(()=>{
			this.scope.$broadcast('queryStringInit');
		});

	}

	isQueryChanged(flag){
		this.isSourceChanged = flag;
	}

	convertColumnObjectToArray(data){
		var array = data;
		if(!Array.isArray(data)){
			array = [];
			var keys = Object.keys(data);
			keys.forEach(function(key){
				var type = undefined;
				if(data[key] === 'int' ||data[key] === 'long' || data[key] === 'short' || data[key] === 'double' || data[key] === 'float' ){
					type = 'number';
				} else if(data[key] === 'date'){
					type = 'datetime';
				} else if(data[key] === 'ipv4' ||data[key] === 'ipv6'){
					type = 'ip';
				} else {
					type = data[key];
				}
				array.push({
					key:key,
					type:type
				});
			})
		}

		return array;
	}

	onDataChanged(data, fieldOrder, fieldTypes) {

		this.dataModel = data;
		this.dataModelForGrid = data.slice(0, 100);
		this.dataFields = fieldOrder;
		if(!this.isStreamWidget){
			this.streamQueryValid = false;
		}

		this.serviceWorkerLogdb.data.getColumnType(this.convertColumnObjectToArray(fieldTypes), types => {
			this.columnInfo = types;
			this.isQueryExecuted = true;
			if(!!this.isSheetLoaded){
				this.bindFields();
			} else {
				this.drawSheet();
			}
			this.isSourceLoading = false;
			this.scope.$apply();
		});
	}

	onIntervalChanged(interval) {
		this.current.widget.interval = interval;
	}

	selectType(t) {
		this.isSheetLoaded = false;
		
		if(!t) {
			return;
		}
		if(!!this.current.type.id === t.id) {
			return;
		}

		let service =  WidgetService.get(t.id);
		this.isStreamWidget = service.constructor.STREAM || false;
		this.isCustomWidget = service.constructor.CUSTOM || false;
		this.current.widget.type = t.id;
		this.clearSheet();
		if(this.isCustomWidget || this.isStreamWidget || !!this.isQueryExecuted){
			this.drawSheet();
		}
	}

	isCustom(){
		return this.isCustomWidget;
	}

	isStream(){
		return this.isStreamWidget;
	}

	drawSheet() {
		this.clearSheet();
		//angular.element('.js-widget-property').empty();
		var el = angular.element('<' + this.current.type.id + '-property style="display:block" ng-model="vm.current.widget" source="vm.dataModelForGrid" types="vm.columnInfo" callback="vm.bindFields"/>');
		this.$compile(el)(this.scope);
		el.appendTo('.js-widget-property');

		this.isSheetLoaded = true;
	}

	clearSheet() {
		angular.element('.js-widget-property').empty();
		this.isSheetLoaded = false;
	}

	clearWidgetContext() {
		this.sourceType = 'instant';
		this.instantQueryString = null;
		this.instantQueryInterval = 5;
		this.selectedDataSource = null;
		this.subcommand = null;
		this.current.name = null;
		this.current.widget = { data: null };
		this.widgetContextForData = { data: null };
		this.current.type = this.widgetTypes[0];
		this.selectType(this.widgetTypes[0]);
		this.isDarkMode = false;
		this.hasPreview = false;
		this.hasProperty = false;
		this.hasError = false;
		this.clearSheet();
	}

	bindFields() {
		if(!this.isSheetLoaded || this.isCustom() || this.isStream()){
			return;
		}
		var ctxcnt = this.el.find('*[context-container]')[0];
		if(!!ctxcnt) {
			ctxcnt.setColumnInfo({
				columnInfo: this.columnInfo,
				fieldOrder: this.dataFields,
				ignoreLastOrder: true
			});
			ctxcnt.setDataModel(JSON.parse( angular.toJson( this.dataModelForGrid )));

			if(Utility.exists('current.widget.data.source.guid', this)) {
				ctxcnt.setHaveDatasource(!!this.current.widget.data.source.guid);
			}
		}
	}

	activeDebug(e) {
		if((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 68) {
			e.preventDefault();
			this.debug = !this.debug;
		}
	}

	onContextContainerChanged(e, ctx) {
		if(!this.widgetContextForData || !this.widgetContextForData.data){
			return;
		}
		this.current.widget.data = Object.assign({}, ctx, this.widgetContextForData.data);
		if(this.widgetContextForData.interval) {
			this.current.widget.interval = this.widgetContextForData.interval;
		}

	}

	toggleDarkMode() {
		if(this.previewWidget) {
			let rendered = this.previewWidget.rendered,
				theme = this.isDarkMode ? 'black' : 'white';
			if(typeof rendered.setStyle === 'function') {
				rendered.setStyle(theme);
			}
		}
	}

	preview() {
		if(!this.isCustom() && !!this.isSourceChanged){
			notify('danger', this.$filter('translate')('$S_msg_QueryModified'), true);
			return;
		}

		if(!!this.previewWidget) {
			if(this.hasError) {
				if (!!this.previewWidget.elTarget) {
					$(this.previewWidget.elTarget).empty();
				}
				$(this.previewWidget.targetElement).empty();
			}else {
				this.previewWidget.destroy();
			}
		}

		let ctxcnt = this.el.find('*[context-container]')[0];
		
		if(this.dataModel.length === 0 ) {
			if( !this.isCustom() || !ctxcnt ){
				notify('danger', this.$filter('translate')('$S_msg_DataSourceRequired'), true);
				return;
			}
		}

		this.current.widget.guid = 'NEW_WIDGET';

			// this.previewWidget = new InstantWidget(this.current.widget, this.store, true, null, null, this.el.find('.js-preview')[0], this.dataModel,  {'theme': this.isDarkMode ? 'black' : 'light'});
		let ctx = undefined; 
		
		if(!!ctxcnt){
			ctx = ctxcnt.getContext();
		}

		if(!!ctx) {
			this.hasPreview = true;
			this.current.widget.data.query = this.widgetContextForData.data.query;
			this.previewWidget = new InstantWidget(this.current.widget, this.store, {
				'isReadOnly': true,
				'elTarget': this.el.find('.js-preview')[0],
				'cache': this.dataModel,
				'theme': this.isDarkMode ? 'black' : 'white',
				'columns': this.columnInfo
			});
			// preview 상태에서 error가 발생했을 때
			this.hasError = Utility.exists('previewWidget.rendered.isError', this) ? Utility.getNamespace('previewWidget.rendered.isError', this) : undefined;
		}else {
			this.hasPreview = false;
			notify('danger', this.$filter('translate')('$S_msg_SetAllTheNecessaryProperties'), true);
			return;
		}
	}

	close() {
		if(!!this.previewWidget) {
			this.previewWidget.destroy();
		}

		this.el[0].hideDialog();
		this.scope.$emit('AddNewWidgetController:onClose');
	}

	isValid() {
		let ctxcnt = this.el.find('*[context-container]')[0];
		let ctx = undefined;
		if(!!ctxcnt){
			ctx = ctxcnt.getContext();
		}

		if(!this.current.name) {
			return false;
		}

		if(this.isStream() && !this.streamQueryValid){
			notify('danger', this.$filter('translate')('$S_msg_AvailableQueries'), true);
			return false;	
		}

		if(!this.isCustom() && !!this.isSourceChanged){
			if(this.isStream()){
				notify('danger', this.$filter('translate')('$S_msg_QueryAgain'), true);
			} else {
				notify('danger', this.$filter('translate')('$S_msg_ReQueryData'), true);	
			}
			
			return false;
		}

		if(!this.current.widget.data && !this.isCustom() && !this.isStream()) {
			notify('danger', this.$filter('translate')('$S_msg_DataSourceRequired'), true);
			return false;
		}
		
		if(!this.isStream() && !this.isCustom() &&!Number.isInteger(this.current.widget.interval)) {
			return false;
		}

		if(!ctx && !this.isStream()) {	// preview가 있거나 없거나
			notify('danger', this.$filter('translate')('$S_msg_SetAllTheNecessaryProperties'), true);
			return false;
		}

		if(this.hasError) {
			notify('danger', this.$filter('translate')('$S_msg_CheckForUndefinedProperties'), true);
			return false;
		}

		return true;
	}

	isStreamable(query , isValid){
		if(!this.current.widget.data){
			return;
		}
		this.current.widget.data.query = query;
		this.streamQueryValid = isValid;
	}

	submit() {
		if(this.isValid()) {
			// added in issue2776, 쿼리 할때 this.widgetContextForData이 query를 바꾸지만 this.current.widget의 내용은 바꾸지 않아 문제가 생김.
			this.current.widget.data.query = this.widgetContextForData.data.query;
			if(this.isCustom()){
				this.current.widget.data.query = "bypass";
				this.current.widget.interval =  (Math.pow(2,31) - 1) / 1000;
				//console.log("this.current interval" ,Number.MAX_SAFE_INTEGER );
			}
			this.close();
			this.scope.$emit('AddNewWidgetController:onSubmit',
				Object.assign(this.current.widget, {name: this.current.name}),
				this.store);
		}
		else {
			this.isOnSubmit = true;
		}
	}
}

export default AddNewWidgetController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/AddNewWidgetController.js